<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="450" persistent>
    <v-card rounded="xl">
      <v-card-title class="text-h6 font-weight-bold pt-5 px-6">
        Cancelar Factura
      </v-card-title>
      <v-card-text class="px-6">
        <v-alert type="warning" dense outlined class="mb-4">
          Esta acción es <strong>irreversible</strong>. La factura será cancelada ante el SAT.
        </v-alert>
        <p class="body-2">
          ¿Estás seguro de que deseas cancelar la factura de esta orden?
        </p>
      </v-card-text>
      <v-card-actions class="pa-4">
        <v-spacer />
        <v-btn text rounded color="grey darken-1" @click="close" :disabled="loading">
          No, regresar
        </v-btn>
        <v-btn
          color="red"
          rounded
          class="white--text font-weight-bold"
          @click="submit"
          :loading="loading"
        >
          Sí, cancelar factura
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Endpoints from "@/share/Endpoints";
import { mapMutations } from "vuex";

export default {
  props: {
    value: { type: Boolean, default: false },
    order: { type: Object, default: null },
  },
  data: () => ({
    loading: false,
  }),
  methods: {
    ...mapMutations("notification", ["show"]),
    close() {
      this.$emit("input", false);
    },
    async submit() {
      this.loading = true;
      try {
        const url = Endpoints.invoicesOrderCancel.replace(/:orderId/, this.order.id);
        const { data } = await this.axios.put(url, { motive: "02" });
        this.show({ text: data.message || "Factura cancelada exitosamente", color: "success", time: 3000 });
        this.$emit("cancelled");
        this.close();
      } catch (error) {
        const msg = error.response?.data?.error?.message || "Error al cancelar la factura";
        this.show({ text: msg, color: "error", time: 4000 });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
